import Information from './Information'
import Setting from './Setting'
import Statement from '../ContentDeliveryNetwork/Statement'
import Monitoring from '../Transcoding/Monitoring'

const Transmuxing = {
    Information,
    Setting,
    Monitoring,
    Statement,
}

export default Transmuxing
